export default __webpack_public_path__ + "static/media/platinum.ce6a66a75986b326d57485e7fbabc591.svg";